import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@jammable/ui-components/Dialog";
import { FaArrowCircleUp } from "react-icons/fa";
import { Subscribe } from "../../../../packages/ui/features/payments/src/Subscribe";
import { primaryButtonStyles, SecondaryButton, toast } from "@jammable/ui-core";
import { Input } from "@jammable/ui-components/Forms";
import VoiceImage from "../VoiceImage";
import NotFound from "../NotFound";
import { Spinner } from "@jammable/ui-components/Loader";
import { useQuery } from "react-query";
import axios from "axios";
import { requireIdToken } from "../../utils/firebaseAuth";
import AddVoiceItem from "../AddVoiceItem";

const AddVoiceModal = ({ open, setOpen, collection }) => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [collectionVoices, setCollectionVoices] = useState(
    collection?.models ?? [],
  );

  const message = "";

  const { data, isLoading } = useQuery(
    ["userVoices", search],
    async () => {
      const token = await requireIdToken();
      const response = await axios.get("/api/model", {
        params: {
          type: "all",
          page: 1,
          limit: 20,
          search: search,
          sortOrder: "desc",
          sortBy: "usesLast24Hours",
        },
        headers: { Authorization: token },
      });

      return response.data;
    },
    { enabled: open },
  );

  return (
    <div className="tw-w-full tw-truncate">
      <div className="tw-text-2xl tw-font-black">Add Voices</div>
      <div className="tw-text-sm tw-text-gray-500 tw-mb-2">
        Choose voices to add to your collection!
      </div>
      <Input
        placeholder="Search voices..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="tw-mb-2 tw-h-14 tw-rounded-full tw-border-2 tw-border-gray-300 tw-px-4 tw-text-lg"
      />
      <div className="tw-max-h-96 tw-overflow-y-auto tw-flex tw-flex-col tw-w-full">
        {isLoading ? (
          <div className="tw-mt-3 tw-w-full tw-flex tw-flex-col tw-gap-3">
            {[...Array(2)].map((_, index) => (
              <div
                key={index}
                className="tw-animate-pulse tw-bg-gray-100 tw-p-3 tw-rounded-xl tw-flex tw-items-center tw-space-x-4"
              >
                <div className="tw-rounded-xl tw-bg-gray-200 tw-size-12"></div>
                <div className="tw-flex-1 tw-space-y-2">
                  <div className="tw-h-4 tw-bg-gray-200 tw-rounded-xl tw-w-3/4"></div>
                  <div className="tw-h-4 tw-bg-gray-200 tw-rounded-xl tw-w-1/2"></div>
                </div>
              </div>
            ))}
          </div>
        ) : !data?.data?.length ? (
          <NotFound
            title="No voices found..."
            description="Try searching for a different voice!"
            animateIn={false}
            className="tw-my-4 tw-text-lg"
          />
        ) : (
          data?.data?.map((voice) => (
            <AddVoiceItem
              voice={voice}
              collection={collection}
              setOpen={setOpen}
              setLoading={setLoading}
              key={voice._id}
              collectionVoices={collectionVoices}
              setCollectionVoices={setCollectionVoices}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default AddVoiceModal;
